<template>
  <div v-if="authState.visible" class="login-mask" @click.self="handleClose">
    <div class="login-dialog">
      <div class="login-left">
        <h2 class="login-title">登录后继续操作</h2>
        <p class="login-desc">登录后将为当前手机号账号开通套餐</p>

        <div class="form-area">
          <label class="input-row" :class="{ error: errorType === 'mobile' }">
            <img class="input-icon" src="@/assets/images/user/phone.svg" alt="手机号">
            <input v-model.trim="mobile" type="tel" maxlength="11" placeholder="请输入手机号">
          </label>

          <label class="input-row code-row" :class="{ error: errorType === 'code' }">
            <img class="input-icon" src="@/assets/images/user/password.svg" alt="验证码">
            <input v-model.trim="verifyCode" type="text" maxlength="6" placeholder="请输入验证码">
            <button class="code-button" type="button" :disabled="authState.countdown > 0" @click="handleGetCode">
              {{ codeButtonText }}
            </button>
          </label>

          <div class="resend-row">
            <span>收不到验证码？</span>
            <button class="link-button" type="button" @click="handleGetCode">重新发送</button>
            <span v-if="authState.countdown > 0">（{{ authState.countdown }}s）</span>
          </div>

          <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

          <button class="submit-button" type="button" :disabled="authState.submitting" @click="handleSubmit">
            {{ authState.submitting ? '登录中...' : '登录 / 注册' }}
          </button>

          <BaseCheckbox v-model="agreed" variant="agreement">
            <span>我已阅读并同意</span>
            <a href="javascript:void(0)" @click.stop>《用户协议》</a>
            <span>和</span>
            <a href="javascript:void(0)" @click.stop>《隐私政策》</a>
          </BaseCheckbox>
        </div>
      </div>

      <div class="safe-tip">
        <img class="safe-icon" src="@/assets/images/icons/lock.svg" alt="安全登录图标">
        <div>
          <span>安全登录，数据加密保护，未注册手机号将自动创建星核DI账号</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/store/auth";
import userCenter from "@/store/userCenter";
import BaseCheckbox from "@/components/BaseCheckbox.vue";

// 常量：手机号格式校验规则，仅允许中国大陆 11 位手机号
const MOBILE_PATTERN = /^1\d{10}$/

export default {
  name: 'GlobalLoginDialog',
  components: {BaseCheckbox},
  data() {
    return {
      authState: auth.state,
      mobile: '',
      verifyCode: '',
      agreed: false,
      errorType: '',
      errorMessage: ''
    }
  },
  computed: {
    // 方法：根据倒计时状态展示验证码按钮文案
    codeButtonText() {
      return this.authState.countdown > 0 ? `${this.authState.countdown}s` : '获取验证码'
    }
  },
  methods: {
    // 方法：关闭登录弹窗并重置当前表单提示
    handleClose() {
      this.errorType = ''
      this.errorMessage = ''
      auth.closeLoginDialog()
    },
    // 方法：校验手机号，供获取验证码和登录共用
    validateMobile() {
      // 逻辑分支：手机号格式不合法时阻止后续动作
      if (!MOBILE_PATTERN.test(this.mobile)) {
        this.errorType = 'mobile'
        this.errorMessage = '请输入正确的手机号'
        return false
      }

      this.errorType = ''
      this.errorMessage = ''
      return true
    },
    // 关键节点：获取验证码并启动 60 秒倒计时
    async handleGetCode() {
      if (!this.validateMobile()) {
        return
      }
      try {
        await auth.sendSmsCode(this.mobile)
      } catch (error) {
        this.errorType = 'mobile'
        this.errorMessage = error.message || '验证码发送失败'
      }
    },
    // 关键节点：提交手机号验证码，登录统一平台。
    async handleSubmit() {
      // 逻辑分支：请求进行中时忽略重复提交，防止并发触发两次 verifySms
      if (this.authState.submitting) {
        return
      }

      if (!this.validateMobile()) {
        return
      }

      // 逻辑分支：验证码为空时提示用户补全
      if (!this.verifyCode) {
        this.errorType = 'code'
        this.errorMessage = '请输入验证码'
        return
      }

      // 逻辑分支：协议未勾选时不允许登录
      if (!this.agreed) {
        this.errorType = 'agreement'
        this.errorMessage = '请先阅读并同意用户协议和隐私政策'
        return
      }

      try {
        const hasPendingAction = await auth.completeLogin(
          this.mobile,
          this.verifyCode
        )
        this.errorType = ''
        this.errorMessage = ''
        if (!hasPendingAction) {
          userCenter.openOverview()
        }
      } catch (error) {
        this.errorType = 'code'
        this.errorMessage = error.message || '手机号或验证码错误'
      }
    }
  }
}
</script>

<style scoped lang="less">
.login-mask{
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.58);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-dialog{
  position: relative;
  width: 522px;
  min-height: 342px;
  border: 2px solid #1F9DFF;
  border-radius: 10px;
  background: #fff;
  padding: 38px 0 14px;
  box-sizing: border-box;
  text-align: center;
  color: #000000D9;
}

.login-left{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-title{
  margin: 0;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  color: #000;
}

.login-desc{
  width: 234px;
  margin: 8px 0 0;
  color: #00000073;
  font-size: 12px;
  line-height: 18px;
}

.form-area{
  width: 234px;
  margin-top: 32px;
}

.input-row{
  width: 234px;
  height: 24px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: #fff;

  &.error{
    border-color: #ff4d4f;
  }

  input{
    flex: 1;
    min-width: 0;
    height: 22px;
    border: none;
    color: #000000D9;
    font-size: 12px;
    line-height: 18px;
    background: transparent;
  }

  input::placeholder{
    color: #BFBFBF;
  }
}

.code-row{
  margin-top: 18px;
}

.input-icon{
  width: 12px;
  height: 12px;
  margin: 0 5px;
  display: block;
}

.code-button{
  width: 80px;
  height: 22px;
  border: none;
  background: transparent;
  color: #2F7BFF;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  text-align: right;
  padding: 0 10px;

  &:disabled{
    color: #999;
    cursor: not-allowed;
  }
}

.resend-row{
  margin-top: 5px;
  height: 18px;
  padding-right: 2px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #BFBFBF;
  font-size: 11px;
  line-height: 18px;
}

.link-button{
  border: none;
  background: transparent;
  color: #2F7BFF;
  font-size: 11px;
  line-height: 18px;
  cursor: pointer;
}

.error-message{
  margin-top: 6px;
  min-height: 18px;
  color: #ff4d4f;
  font-size: 11px;
  line-height: 18px;
}

.submit-button{
  width: 234px;
  height: 28px;
  margin-top: 18px;
  border: none;
  border-radius: 4px;
  background: linear-gradient(108deg, #7FDBFF 0%, #367CFF 48%, #8AAEFF 100%);
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;

  &:disabled{
    color: #A6ADBA;
    background: #E7EAF0;
    cursor: not-allowed;
  }
}

.safe-tip{
  position: absolute;
  left: 0;
  bottom: 13px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #A6A6A6;
  font-size: 11px;
  line-height: 18px;

  .safe-icon{
    width: 14px;
    height: 14px;
    margin-right: 7px;
    display: block;
  }

  div{
    display: flex;
    flex-direction: column;
  }

  span{
    color: #BFBFBF;
  }
}
</style>
